"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireDefault(require("react"));
var _carouselImages = _interopRequireDefault(require("../styles/carousel-images.css"));
var CarouselSingleText = /*#__PURE__*/function (_React$Component) {
  (0, _inheritsLoose2["default"])(CarouselSingleText, _React$Component);
  function CarouselSingleText() {
    return _React$Component.apply(this, arguments) || this;
  }
  var _proto = CarouselSingleText.prototype;
  _proto.componentDidMount = function componentDidMount() {
    if (this.props.updateTextBoxSizes && typeof this.props.updateTextBoxSizes === 'function') {
      this.props.updateTextBoxSizes(this.textContainer.clientHeight);
    }
  };
  _proto.render = function render() {
    var _this = this;
    var _this$props = this.props,
      paragraph = _this$props.paragraph,
      index = _this$props.index,
      theme = _this$props.theme;
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _carouselImages["default"].carouselTextContainer + " " + theme.marginTop20 + " " + theme['col-xs-12'] + " " + theme['col-sm-10'],
      ref: function ref(el) {
        return _this.textContainer = el;
      }
    }, paragraph === null ? /*#__PURE__*/_react["default"].createElement("div", {
      className: (index === 0 && _carouselImages["default"].visibleText) + " " + _carouselImages["default"].carouselText + " " + theme.smallType
    }, "\xA0") : /*#__PURE__*/_react["default"].createElement("div", {
      className: (index === 0 && _carouselImages["default"].visibleText) + " " + _carouselImages["default"].carouselText + " " + theme.smallType,
      dangerouslySetInnerHTML: {
        __html: paragraph
      }
    }));
  };
  return CarouselSingleText;
}(_react["default"].Component);
exports["default"] = CarouselSingleText;